const env = {
  SERVER: process.env.REACT_APP_SERVER,
  API_URL: process.env.REACT_APP_API_URL,
  G_MAP_API_KEY: process.env.REACT_APP_G_MAP_API_KEY,
  STRIPE: {
    PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
    CLIENT_ID: process.env.REACT_APP_STRIPE_CLIENT_ID,
  },
}

export default env
